import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: 'prompt'
        }
    }

    init() {

    }

    prompt(e) {
        e.preventDefault();

        if(confirm(this.getData('text'))) {
            window.location = this.getData('href');
        } else {
            return false;
        }
    }
}
